module.exports = __webpack_public_path__ + "static/people_img1-b616910303b02a37f89a104a1c540bc1.png";